import React from "react";
import { Container } from "../../../components";
import { Text, Heading } from "@telia/teddy";
import TEXT from "../../text-consts";

const RejectReceipt: React.FC = () => {
    return (
        <div className="consent-landing-page">
            <div className="consent-landing-page__heading-container">
                <Heading mb="100" as="h2" variant="title-200">
                    {TEXT.CONSENT_FORMER_LEGAL.REJECTED.HEADING}
                </Heading>
            </div>
            <Container size="medium">
                <section>
                    <Text mb="100" variant="additional-100">
                        {TEXT.CONSENT_FORMER_LEGAL.REJECTED.DESCRIPTION}
                    </Text>
                </section>
            </Container>
        </div>
    );
};

export default RejectReceipt;
